import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'scaffold-loading-animation',
    templateUrl: './loading-animation.component.html',
    styleUrls: ['./loading-animation.component.scss'],
    standalone: false
})
export class LoadingAnimationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
